<template>
  <component
    v-bind = "containerTag.props"
    :is = "containerTag.name">
    <slot name = "before-name" />
    <component
      v-bind = "{...parrierTag.props, ...customBind.name || {} }"
      :is = "parrierTag.name">
      <v-text-field
        v-bind = "{ ...customBind.nameInput || {} , ...textFieldProps}"
        v-model = "input.name"
        placeholder = "Broadcast Name" />
    </component>
    <slot v-if = "!put" name = "before-channel" />
    <component
      v-if = "!put"
      v-bind = "{...parrierTag.props, ...customBind.channel || {} }"
      :is = "parrierTag.name">
      <v-radio-group v-model="input.channel" mandatory @change = "getApps" row>
        <v-radio value="whatsapp">
          <span slot = "label" class = "platform-wrapper white--text green accent-4 botter-whatsapp-icon" />
        </v-radio>
       <!--  <v-radio value="messenger">
          <span slot = "label" class = "platform-wrapper white--text blue botter-messenger-icon" />
        </v-radio> -->
        <v-radio value="facebook">
          <v-icon slot = "label" class = "platform-wrapper white--text blue darken-2" >facebook</v-icon>
        </v-radio>
        <!-- <v-radio value="twitter">
          <span slot = "label" class = "platform-wrapper white--text blue botter-twitter-icon" />
        </v-radio> -->
      </v-radio-group>
    </component>
    <slot v-if = "!put" name = "before-app" />
    <component
      v-if = "!put"
      v-bind = "{...parrierTag.props, ...customBind.app || {} }"
      :is = "parrierTag.name">
      <v-select
        v-model = "input.app"
        :items = "apps"
        item-text = "name"
        :item-value = "v => v"
        no-data-text = "No Apps for this channel"
        placeholder = "Select App" />
    </component>
    <slot
      v-for = "(slot, s) in new Array(slots)"
      :name = "`tail-slot-${ s + 1 }`" />
  </component>
</template>

<script>
export default {
  name: 'AddBroadcast',
  props: {
    containerTag: {
      type: Object,
      default() {
        return {
          name: 'div',
          props: {
            class: ''
          }
        }
      }
    },
    parrierTag: {
      type: Object,
      default() {
        return {
          name: 'div',
          props: {
            class: ''
          }
        }
      }
    },
    textFieldProps: {
      type: Object,
      default() {
        return {
          outline: true
        }
      }
    },
    slots: {
      type: Number,
      default: 2
    },
    customBind: {
      type: Object,
      default() {
        return {}
      }
    },
    put: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      isValid: false,
      apps: [],
      input: {
        name: '',
        channel: 'whatsapp',
        app: null
      }
    }
  },
  watch: {
    put(val) {
      if (val) this.input = val
      else this.resetForm()
    }
  },
  mounted() {
    this.getApps()
  },
  methods: {
    getApps() {
      this.input.app = null
      const botId = this.$store.state.bot.botId
      this.$http_chat.get(`/bots/${botId}/apps?channel=${this.input.channel}`).then(res => {
        this.apps = res.data.data
      })
    },
    submit() {
      if (this.input.name.length && this.input.channel.length && this.input.app) {
        this.emitLoading(true)
        const payload = this.put ? { name: this.put.name, id: this.put.id } : { ...this.input, bot_id: this.$store.state.bot.botId }
        this.$store.dispatch(`broadcasts/${this.put ? 'update' : 'add'}`, payload)
        .then((response)=>{
          this.resetForm()
          this.emitLoading(false)
          this.$emit('success', response.data)
        })
        .catch((err) => {
          this.emitLoading(false)
          this.$store.dispatch('setErrorMessage', true)
          this.$emit('error', err)
        })
      }
    },
    async resetForm() {
      this.input = {
        name: '',
        channel: 'whatsapp'
      }
      return true
    },
    emitLoading(status = true) {
      this.$emit('loading', status)
    }
  }
}
</script>

<style lang="css" scoped>
.platform-wrapper {
  border-radius: 50%;
  padding: 5px;
  height: 30px;
  width: 30px;
  
  font-size: 20px;
}
</style>
